export enum StaffActivityDescriptions {
  AA_MockPortal = "AA Mock Portal",
  AL_BirminghamFireDept = "Birmingham Fire Department Questionaire",
  AL_MorganCountyLEPC = "Morgan County LEPC Questionaire",
  AL_HomewoodFireDept = "Homewood Fire Department Questionaire",
  AR_ArkansasInvoice = "Arkansas Invoice",
  AR_ArkansasPortal = "Arkansas Portal",
  AR_ArkansasTier2Submit = "Arkansas Tier2 Submit",
  AZ_ArizonaPortal = "Arizona State Portal",
  AZ_SendToCustomerToCertify = "Arizona - Send to Customer to Certify",
  AZ_DownloadReport = "Arizona - Download Report",
  CA_CaliforniaPortal = "California State Portal",
  CO_ColoradoSpringsPortal = "Colorado Springs Portal",
  CO_ColoradoTier2Submit = "Colorado Tier2 Submit",
  CO_ColoradoTier2SubmitRevision = "Colorado Tier2 Submit - Revision",
  CT_ConnecticutPortal = "Connecticut State Portal",
  DE_DelawarePortal = "Delaware State Portal",
  FL_FloridaEPlan = "Florida ePlan",
  HI_HawaiiTier2Submit = "Hawaii Tier2 Submit",
  ID_IdahoFallsForm = "Idaho Falls Form",
  IL_ChicagoPortal = "Chicago Portal",
  IL_IllinoisPortal = "Illinois State Portal",
  IN_IndianaInvoice = "Indiana Invoice",
  IN_IndianaPortal = "Indiana State Portal",
  KS_FordCountyLEPC = "Ford County LEPC",
  KS_KansasInvoice = "Kansas Invoice",
  KS_KansasPortal = "Kansas State Portal",
  KS_KansasCityKansasFireDept = "Kansas City, Kansas Fire Dept Portal",
  KS_LenexaFireDeptPortal = "Lenexa Fire Dept Portal",
  KY_KentuckyInvoice = "Kentucky Invoice",
  KY_KentuckyPortal = "Kentucky State Portal",
  LA_EastBatonRougePortal = "East Baton Rouge Portal",
  LA_LouisianaInvoice = "Louisiana Invoice",
  LA_RapidesParishEPC = "Rapides Parish EPC Fees",
  MA_MassachusettsPortal = "Massachusetts State Portal",
  MD_HowardPortal = "Howard County Portal",
  MD_MarylandInvoice = "Maryland Invoice",
  MD_MarylandPortal = "Maryland State Portal",
  MD_MontgomeryPortal = "Montgomery County Portal",
  ME_MaineCertLetterSubjectToEmergencyPlanning = "Maine Certification Letter - Subject to Emergency Planning",
  ME_MaineCertLetterNotSubjectToEmergencyPlanning = "Maine Certification Letter - Not Subject to Emergency Planning",
  MI_MichiganPortal = "Michigan State Portal",
  MN_MinnesotaPortal = "Minnesota State Portal",
  MO_MissouriInvoice = "Missouri Invoice",
  MO_MissouriPortal = "Missouri State Portal",
  NC_AlamancePortal = "Alamance County Portal",
  NC_MecklenburgPortal = "Mecklenburg County LEPC",
  NC_NorthCarolinaEPlan = "North Carolina ePlan",
  ND_NorthDakotaInvoice = "North Dakota Invoice",
  ND_NorthDakotaPortal = "North Dakota State Portal",
  NE_NebraskaPortal = "Nebraska State Portal",
  NH_NewHampshireTier2Submit = "New Hampshire Tier2 Submit",
  NJ_HowellTownshipFormAndFees = "Howell Township Form and Fees",
  NJ_NewJerseyPortal = "New Jersey State Portal",
  NM_NewMexicoCoverLetter = "New Mexico Cover Letter",
  NV_NevadaInvoice = "Nevada Invoice",
  NV_NevadaPortal = "Nevada State Portal",
  NY_NewYorkCityPortal = "New York City Portal",
  NY_NycThresholdReview = "Staff - NYC Threshold Review",
  OH_CityOfCleveland = "City of Cleveland",
  OH_ClevelandFireDept = "Cleveland Fire Department",
  OH_FeeWorksheet = "Ohio Fee Worksheet",
  OH_OhioCertForm = "Ohio Certification Form",
  OH_WarrenPortal = "Warren County Portal",
  OK_OklahomaTier2Submit = "Oklahoma Tier2 Submit",
  OR_OregonPortal = "Oregon State Portal",
  OR_OregonMultnomahCountyLEPC = "Multnomah County LEPC (Portland Water Bureau)",
  PA_BerksPortal = "Berks County Portal",
  PA_CentreCountyInvoice = "Complete Centre County Invoice",
  PA_CrawfordCountyInvoice = "Complete Crawford County Invoice",
  PA_MontgomeryCountyPortal = "Montgomery, PA County Portal",
  PA_PennsylvaniaPortal = "Pennsylvania State Portal",
  PA_PennsylvaniaPortalRevision = "Pennsylvania State Portal - Revision",
  PA_PotterCountyInvoice = "Complete Potter County Invoice",
  PA_PotterCountyLEPC = "Potter County LEPC",
  PA_WashingtonCountyInvoice = "Complete Washington County Invoice",
  PR_PuertoRicoTier2Submit = "Puerto Rico Tier2 Submit",
  RI_RightToKnowAnnualRegistrationForm = "Right-to-Know Annual Registration Form",
  SC_RichlandCountyFormAndFees = "Richland County Form and Fees",
  SD_SouthDakotaPortal = "South Dakota State Portal",
  TX_TexasPortal = "Texas State Portal",
  TX_PlanoFireRescuePortal = "Plano Fire-Rescue Portal",
  UT_DavisCountyPortal = "Davis County Portal",
  UT_SaltLakeCityPortal = "Salt Lake City Portal",
  UT_TooelePortal = "Tooele County Portal",
  UT_UtahCountyPortal = "Utah County Portal",
  UT_UtahTier2Submit = "Utah Tier2 Submit",
  VA_CarolineLEPCPortal = "Caroline County LEPC Portal",
  VA_FairfaxPortal = "Fairfax County Portal",
  VA_FredericksburgLEPCPortal = "Fredericksburg LEPC Portal",
  VA_HenricoPortal = "Henrico County Portal",
  VA_KingGeorgeLEPCPortal = "King George County LEPC Portal",
  VA_LynchburgPortal = "City of Lynchburg Portal",
  VA_MecklenburgLEPCPortal = "Mecklenburg County LEPC Portal",
  VA_NewportNewsFireDepartmentPortal = "Newport News Fire Department Portal",
  VA_PeninsulaJointLEPCPortal = "Peninsula Joint LEPC (Newport News)",
  VA_PrinceWilliamCountyPortal = "Prince William County Portal",
  VA_RichmondCityPortal = "Richmond City Portal",
  VA_RoanokeLEPCPortal = "Roanoke Valley Joint LEPC Portal",
  VA_SpotsylvaniaLEPCPortal = "Spotsylvania County LEPC Portal",
  VA_StaffordLEPCPortal = "Stafford County LEPC Portal",
  VA_VirginiaCertLetter = "Virginia Certification Letter",
  VT_VermontTier2Submit = "Vermont Tier2 Submit",
  WA_WashingtonPortal = "Washington State Portal",
  WI_WisconsinPortal = "Wisconsin State Portal",
  WV_WestVirginiaInvoice = "West Virginia Invoice",
  WV_WestVirginiaPortal = "West Virginia State Portal",
  WV_WestVirginiaPortalOilAndGas = "West Virginia State Portal - Oil and Gas",
  WY_WyomingTier2Submit = "Wyoming Tier2 Submit",
}

export const LEGACY_STAFF_ACTIVITY_DESCRIPTIONS = {
  "AA Mock Invoice - Once Per Credential":
    StaffActivityDescriptions.AA_MockPortal,
  "Alamance County Portal": StaffActivityDescriptions.NC_AlamancePortal,
  "Arizona Portal": StaffActivityDescriptions.AZ_ArizonaPortal,
  "Arizona - Send to Customer to Certify":
    StaffActivityDescriptions.AZ_SendToCustomerToCertify,
  // Keep for backward compatibility
  "Send to Customer to Certify":
    StaffActivityDescriptions.AZ_SendToCustomerToCertify,
  "Download Report": StaffActivityDescriptions.AZ_DownloadReport,
  "Arkansas Invoice - Once Per Credential":
    StaffActivityDescriptions.AR_ArkansasInvoice,
  "Arkansas Portal": StaffActivityDescriptions.AR_ArkansasPortal,
  "Arkansas Tier2 Submit": StaffActivityDescriptions.AR_ArkansasTier2Submit,
  "Berks County Portal": StaffActivityDescriptions.PA_BerksPortal,
  "Birmingham Fire Department Questionaire":
    StaffActivityDescriptions.AL_BirminghamFireDept,
  "California Portal": StaffActivityDescriptions.CA_CaliforniaPortal,
  "Caroline County LEPC Portal":
    StaffActivityDescriptions.VA_CarolineLEPCPortal,
  "Chicago Portal": StaffActivityDescriptions.IL_ChicagoPortal,
  "City of Cleveland": StaffActivityDescriptions.OH_CityOfCleveland,
  "City of Fredericksburg LEPC Portal":
    StaffActivityDescriptions.VA_FredericksburgLEPCPortal,
  "City of Richmond Portal": StaffActivityDescriptions.VA_RichmondCityPortal,
  "Cleveland Fire Department": StaffActivityDescriptions.OH_ClevelandFireDept,
  "Colorado Springs Portal": StaffActivityDescriptions.CO_ColoradoSpringsPortal,
  "Colorado Tier2 Submit": StaffActivityDescriptions.CO_ColoradoTier2Submit,
  "Colorado Tier2 Submit - Revision":
    StaffActivityDescriptions.CO_ColoradoTier2SubmitRevision,
  "Connecticut Portal": StaffActivityDescriptions.CT_ConnecticutPortal,
  "Davis County Portal": StaffActivityDescriptions.UT_DavisCountyPortal,
  "Delaware Portal": StaffActivityDescriptions.DE_DelawarePortal,
  "East Baton Rouge Portal": StaffActivityDescriptions.LA_EastBatonRougePortal,
  "Fairfax County Portal": StaffActivityDescriptions.VA_FairfaxPortal,
  "Fee Worksheet": StaffActivityDescriptions.OH_FeeWorksheet,
  "Florida ePlan": StaffActivityDescriptions.FL_FloridaEPlan,
  "Ford County LEPC": StaffActivityDescriptions.KS_FordCountyLEPC,
  "Hawaii Tier2 Submit": StaffActivityDescriptions.HI_HawaiiTier2Submit,
  "Henrico County Portal": StaffActivityDescriptions.VA_HenricoPortal,
  "Homewood Fire Department Questionaire":
    StaffActivityDescriptions.AL_HomewoodFireDept,
  "Howard County Portal": StaffActivityDescriptions.MD_HowardPortal,
  "Howell Township Form and Fees":
    StaffActivityDescriptions.NJ_HowellTownshipFormAndFees,
  "Idaho Falls Form": StaffActivityDescriptions.ID_IdahoFallsForm,
  "Illinois Portal": StaffActivityDescriptions.IL_IllinoisPortal,
  "Indiana Invoice - Once Per Credential":
    StaffActivityDescriptions.IN_IndianaInvoice,
  "Indiana Portal": StaffActivityDescriptions.IN_IndianaPortal,
  "Kansas City, Kansas Fire Dept Portal":
    StaffActivityDescriptions.KS_KansasCityKansasFireDept,
  "Kansas Invoice - Once Per Credential":
    StaffActivityDescriptions.KS_KansasInvoice,
  "Kansas Portal": StaffActivityDescriptions.KS_KansasPortal,
  "Kentucky Invoice - Once Per Credential":
    StaffActivityDescriptions.KY_KentuckyInvoice,
  "Kentucky Portal": StaffActivityDescriptions.KY_KentuckyPortal,
  "King George County LEPC Portal":
    StaffActivityDescriptions.VA_KingGeorgeLEPCPortal,
  "Lenexa Fire Dept Portal": StaffActivityDescriptions.KS_LenexaFireDeptPortal,
  "Louisiana Invoice - Once Per Credential":
    StaffActivityDescriptions.LA_LouisianaInvoice,
  "Maine Certification Letter - Subject to Emergency Planning":
    StaffActivityDescriptions.ME_MaineCertLetterSubjectToEmergencyPlanning,
  "Maine Certification Letter - Not Subject to Emergency Planning":
    StaffActivityDescriptions.ME_MaineCertLetterNotSubjectToEmergencyPlanning,
  "Maryland Invoice - Once Per Credential":
    StaffActivityDescriptions.MD_MarylandInvoice,
  "Maryland Portal": StaffActivityDescriptions.MD_MarylandPortal,
  "Massachusetts Portal": StaffActivityDescriptions.MA_MassachusettsPortal,
  "Mecklenburg County LEPC": StaffActivityDescriptions.NC_MecklenburgPortal,
  "Michigan Portal": StaffActivityDescriptions.MI_MichiganPortal,
  "Minnesota Portal": StaffActivityDescriptions.MN_MinnesotaPortal,
  "Missouri Invoice - Once Per Credential":
    StaffActivityDescriptions.MO_MissouriInvoice,
  "Missouri Invoice - Once Per Company":
    StaffActivityDescriptions.MO_MissouriInvoice,
  "Missouri Portal": StaffActivityDescriptions.MO_MissouriPortal,
  "Montgomery County Portal": StaffActivityDescriptions.MD_MontgomeryPortal,
  "Morgan County LEPC Questionaire":
    StaffActivityDescriptions.AL_MorganCountyLEPC,
  "Nebraska Portal": StaffActivityDescriptions.NE_NebraskaPortal,
  "Nevada Invoice - Once Per Credential":
    StaffActivityDescriptions.NV_NevadaInvoice,
  "Nevada Portal": StaffActivityDescriptions.NV_NevadaPortal,
  "New Hampshire Tier2 Submit":
    StaffActivityDescriptions.NH_NewHampshireTier2Submit,
  "New Jersey Portal": StaffActivityDescriptions.NJ_NewJerseyPortal,
  "New Mexico Cover Letter - Once Per Organization":
    StaffActivityDescriptions.NM_NewMexicoCoverLetter,
  "New York City Portal": StaffActivityDescriptions.NY_NewYorkCityPortal,
  "Staff - NYC Threshold Review":
    StaffActivityDescriptions.NY_NycThresholdReview,
  "Newport News Fire Department Portal":
    StaffActivityDescriptions.VA_NewportNewsFireDepartmentPortal,
  "North Carolina ePlan": StaffActivityDescriptions.NC_NorthCarolinaEPlan,
  "North Dakota Invoice - Once Per Credential":
    StaffActivityDescriptions.ND_NorthDakotaInvoice,
  "North Dakota Portal": StaffActivityDescriptions.ND_NorthDakotaPortal,
  "Ohio Certification Form": StaffActivityDescriptions.OH_OhioCertForm,
  "Oklahoma Tier2 Submit - Once Per Credential":
    StaffActivityDescriptions.OK_OklahomaTier2Submit,
  "Oregon Portal": StaffActivityDescriptions.OR_OregonPortal,
  "Multnomah County LEPC (Portland Water Bureau)":
    StaffActivityDescriptions.OR_OregonMultnomahCountyLEPC,
  "Peninsula Joint LEPC (Newport News)":
    StaffActivityDescriptions.VA_PeninsulaJointLEPCPortal,
  "Montgomery, PA County Portal":
    StaffActivityDescriptions.PA_MontgomeryCountyPortal,
  "Pennsylvania Portal": StaffActivityDescriptions.PA_PennsylvaniaPortal,
  "Pennsylvania Portal - Revision":
    StaffActivityDescriptions.PA_PennsylvaniaPortalRevision,
  "Potter County LEPC": StaffActivityDescriptions.PA_PotterCountyLEPC,
  "Complete Centre County Invoice":
    StaffActivityDescriptions.PA_CentreCountyInvoice,
  "Complete Crawford County Invoice":
    StaffActivityDescriptions.PA_CrawfordCountyInvoice,
  "Complete Potter County Invoice":
    StaffActivityDescriptions.PA_PotterCountyInvoice,
  "Complete Washington County Invoice":
    StaffActivityDescriptions.PA_WashingtonCountyInvoice,
  "Prince William County Portal":
    StaffActivityDescriptions.VA_PrinceWilliamCountyPortal,
  "Puerto Rico Tier2 Submit":
    StaffActivityDescriptions.PR_PuertoRicoTier2Submit,
  "Rapides Parish EPC Fees": StaffActivityDescriptions.LA_RapidesParishEPC,
  "Right-to-Know Annual Registration Form":
    StaffActivityDescriptions.RI_RightToKnowAnnualRegistrationForm,
  "Richland County Form and Fees":
    StaffActivityDescriptions.SC_RichlandCountyFormAndFees,
  "Roanoke Valley Joint LEPC Portal":
    StaffActivityDescriptions.VA_RoanokeLEPCPortal,
  "Salt Lake City Portal": StaffActivityDescriptions.UT_SaltLakeCityPortal,
  "South Dakota Portal": StaffActivityDescriptions.SD_SouthDakotaPortal,
  "Spotsylvania County LEPC Portal":
    StaffActivityDescriptions.VA_SpotsylvaniaLEPCPortal,
  "Stafford County LEPC Portal":
    StaffActivityDescriptions.VA_StaffordLEPCPortal,
  "City of Lynchburg Portal": StaffActivityDescriptions.VA_LynchburgPortal,
  "Mecklenburg County LEPC Portal":
    StaffActivityDescriptions.VA_MecklenburgLEPCPortal,
  "Texas Portal - Once Per CN": StaffActivityDescriptions.TX_TexasPortal,
  "Plano Fire-Rescue Portal":
    StaffActivityDescriptions.TX_PlanoFireRescuePortal,
  "Tooele County Portal": StaffActivityDescriptions.UT_TooelePortal,
  "Utah County Portal": StaffActivityDescriptions.UT_UtahCountyPortal,
  "Utah Tier2 Submit": StaffActivityDescriptions.UT_UtahTier2Submit,
  "Vermont Tier2 Submit": StaffActivityDescriptions.VT_VermontTier2Submit,
  "Virginia Certification Letter":
    StaffActivityDescriptions.VA_VirginiaCertLetter,
  "Warren County Portal": StaffActivityDescriptions.OH_WarrenPortal,
  "Washington Portal": StaffActivityDescriptions.WA_WashingtonPortal,
  "West Virginia Invoice - Once Per Credential":
    StaffActivityDescriptions.WV_WestVirginiaInvoice,
  "West Virginia Portal": StaffActivityDescriptions.WV_WestVirginiaPortal,
  "West Virginia Portal - Oil and Gas":
    StaffActivityDescriptions.WV_WestVirginiaPortalOilAndGas,
  "Wisconsin Portal": StaffActivityDescriptions.WI_WisconsinPortal,
  "Wyoming Tier2 Submit": StaffActivityDescriptions.WY_WyomingTier2Submit,
};

export type LegacyDescription = keyof typeof LEGACY_STAFF_ACTIVITY_DESCRIPTIONS;
